var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 788 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0f0f44;\n      }\n\n      .st1 {\n        fill: #aa8558;\n      }\n\n      .st2 {\n        fill: #201f47;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.11,182.55c0,.54-.11,1.04-.32,1.51-.22.47-.5.9-.87,1.27-.36.38-.79.67-1.27.89-.48.22-1.01.32-1.57.32h-8.88c-1.05,0-2.04-.2-2.97-.61-.93-.4-1.74-.96-2.44-1.66s-1.25-1.51-1.66-2.44c-.4-.93-.61-1.92-.61-2.97v-4.84h3.23v4.84c0,.62.11,1.2.34,1.74.23.54.54,1.01.95,1.41.4.4.88.72,1.41.95.54.23,1.12.34,1.74.34h8.88c.22,0,.4-.07.57-.22.16-.15.24-.33.24-.54,0-.24-.13-.5-.4-.77l-6.42-6.5,2.26-2.26,2.99,3.03h5.21v3.23h-1.94l.2.2c.89.89,1.33,1.91,1.33,3.07h0ZM80.38,190.46l-2.26,2.04-2.02-1.78,2.3-2.07,1.98,1.82h0ZM85.23,190.46l-2.26,2.04-2.02-1.78,2.3-2.07,1.98,1.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.65,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.73,176.39c.23-.23.52-.34.87-.34h8.07v3.23h-8.07c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.8,176.39c.23-.23.52-.34.87-.34h8.07v3.23h-8.07c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.88,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.95,176.39c.23-.23.52-.34.87-.34h8.07v3.23h-8.07c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.03,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.1,176.39c.23-.23.52-.34.87-.34h4.44v-9.69h3.23v9.69h4.44v3.23h-12.11c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0ZM147.01,183.36l-2.26,2.26-2.02-1.98,2.3-2.3,1.98,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.22,176.39c.23-.23.52-.34.87-.34h2.42v-18.57h3.23v14.25l3.51-2.75c1.4-1.1,2.72-1.88,3.96-2.34s2.37-.69,3.39-.69,1.87.15,2.62.46,1.39.73,1.9,1.27c.51.54.9,1.18,1.17,1.92s.4,1.54.4,2.4v4.04h2.42v3.23h-25.03c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0ZM169.72,169.99c-.5-.54-1.22-.81-2.16-.81-.7,0-1.49.17-2.36.53-.87.35-1.86.96-2.97,1.82l-5.49,4.28v.24h13.73v-4.04c0-.81-.25-1.48-.75-2.02h0ZM166.39,161.15l-2.26,2.26-2.02-1.98,2.3-2.3,1.98,2.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.25,176.39c.23-.23.52-.34.87-.34h2.42v-1.29c0-1.1.18-2.05.52-2.85.35-.79.82-1.45,1.41-1.98.59-.52,1.28-.92,2.06-1.17.78-.26,1.6-.38,2.46-.38s1.68.13,2.46.38c.78.26,1.47.65,2.06,1.17.59.53,1.06,1.18,1.41,1.98.35.79.52,1.74.52,2.85v1.29h2.42v3.23h-3.11c-.48,1-1.25,1.75-2.28,2.26-1.04.51-2.2.77-3.49.77s-2.46-.26-3.51-.77c-1.05-.51-1.82-1.26-2.3-2.26h-3.07c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h.02ZM182.74,178.41c.65.44,1.4.67,2.26.67s1.62-.22,2.26-.67c.65-.44.97-1.1.97-1.96v-1.7c0-1.1-.32-1.9-.97-2.4s-1.4-.75-2.26-.75-1.61.25-2.26.75-.97,1.3-.97,2.4v1.7c0,.86.32,1.51.97,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.35,157.48v21.8h-6.46c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87.23-.23.52-.34.87-.34h3.23v-18.57h3.23,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.42,179.28h-3.23v-21.8h3.23v21.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.11,179.28c-.62,0-1.2-.11-1.74-.34-.54-.23-1.01-.54-1.41-.95-.4-.4-.72-.88-.95-1.41-.23-.54-.34-1.12-.34-1.74v-1.21c0-1.24.18-2.31.52-3.23.35-.92.83-1.67,1.43-2.26.61-.59,1.31-1.04,2.1-1.33.79-.3,1.65-.44,2.56-.44,1.24,0,2.4.2,3.49.59,1.09.39,2.03.96,2.81,1.72v11.02c0,1.13-.15,2.09-.44,2.87-.3.78-.71,1.41-1.23,1.88-.52.47-1.14.81-1.84,1.01-.7.2-1.45.3-2.26.3-1.02,0-2.09-.13-3.21-.4s-2.23-.61-3.33-1.01c.22-.67.39-1.18.52-1.53.13-.35.23-.61.28-.77l.12-.32c.46.19,1.13.41,2.02.67s1.79.38,2.71.38c.43,0,.85-.05,1.27-.14.42-.09.79-.26,1.11-.48.32-.23.58-.54.77-.93.19-.39.28-.89.28-1.51v-.4h-5.25v-.04ZM223.36,170.36c-.97-.51-1.99-.77-3.07-.77-.94,0-1.74.32-2.4.97s-.99,1.67-.99,3.07v1.21c0,.32.12.61.36.85.24.24.52.36.85.36h5.25v-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.67,168.48c-.65-.15-1.27-.22-1.86-.22-1.02,0-1.88.33-2.56.99-.69.66-1.03,1.85-1.03,3.57v1.21h6.06c.7,0,1.28.23,1.74.69s.69,1.04.69,1.74v1.62c0,1.08-.2,2.08-.61,3.01s-.95,1.74-1.64,2.42c-.69.69-1.49,1.23-2.42,1.63-.93.4-1.93.61-3.01.61h-6.86c-1.08,0-2.08-.2-3.01-.61-.93-.4-1.74-.95-2.42-1.63-.69-.69-1.23-1.49-1.63-2.42-.4-.93-.61-1.93-.61-3.01v-4.44h3.23v4.44c0,.62.11,1.2.34,1.74.23.54.54,1.01.95,1.41.4.4.88.72,1.41.95.54.23,1.12.34,1.74.34h6.86c.62,0,1.2-.11,1.74-.34.54-.23,1.01-.54,1.41-.95.4-.4.72-.88.95-1.41.23-.54.34-1.12.34-1.74v-.81h-6.06c-.7,0-1.28-.23-1.74-.69s-.69-1.04-.69-1.74v-2.02c0-2.66.61-4.61,1.82-5.83s2.81-1.84,4.8-1.84c1.35,0,3.01.31,5.01.93l-1.05,2.99c-.62-.24-1.25-.44-1.9-.58h0ZM248.35,189.25l-2.26,2.04-2.02-1.78,2.3-2.07,1.98,1.82h0ZM253.2,189.25l-2.26,2.04-2.02-1.78,2.3-2.07,1.98,1.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.75,169.18c-.58-.27-1.29-.4-2.12-.4-.67,0-1.37.09-2.1.26s-1.4.41-2.02.71l-.65-3.11c.73-.35,1.52-.62,2.38-.81s1.7-.28,2.5-.28,1.57.09,2.3.28c.73.19,1.37.48,1.94.87.57.39,1.02.89,1.35,1.51s.5,1.35.5,2.18v5.65h2.83v3.23h-14.94v-3.23h8.88v-5.65c0-.54-.29-.94-.87-1.21h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.81,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.89,176.39c.23-.23.52-.34.87-.34h8.07v3.23h-8.07c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M293.96,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.04,176.39c.23-.23.52-.34.87-.34h8.07v3.23h-8.07c-.35,0-.64-.11-.87-.34-.23-.23-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.11,176.39c.23-.23.52-.34.87-.34h8.08v3.23h-8.08c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.19,176.39c.23-.23.52-.34.87-.34h4.44v-9.69h3.23v9.69h4.44v3.23h-12.11c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0ZM327.09,161.15l-2.26,2.26-2.02-1.98,2.3-2.3,1.98,2.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.3,176.39c.23-.23.52-.34.87-.34h2.42v-1.29c0-1.1.17-2.05.52-2.85s.82-1.45,1.41-1.98c.59-.52,1.28-.92,2.06-1.17.78-.26,1.6-.38,2.46-.38s1.68.13,2.46.38c.78.26,1.47.65,2.06,1.17.59.53,1.06,1.18,1.41,1.98s.53,1.74.53,2.85v1.29h2.42v3.23h-3.11c-.48,1-1.25,1.75-2.28,2.26-1.04.51-2.2.77-3.49.77s-2.46-.26-3.51-.77c-1.05-.51-1.82-1.26-2.3-2.26h-3.07c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0ZM337.79,178.41c.65.44,1.4.67,2.26.67s1.61-.22,2.26-.67c.65-.44.97-1.1.97-1.96v-1.7c0-1.1-.32-1.9-.97-2.4s-1.4-.75-2.26-.75-1.62.25-2.26.75c-.65.5-.97,1.3-.97,2.4v1.7c0,.86.32,1.51.97,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.07,176.39c.23-.23.52-.34.87-.34h2.83v-18.57h3.23v18.57h2.83v3.23h-8.88c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.95,176.39c.23-.23.52-.34.87-.34h3.23v-18.57h3.23v21.8h-6.46c-.35,0-.64-.11-.87-.34s-.34-.52-.34-.87v-.81c0-.35.11-.64.34-.87h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.02,124.52h8.35v8.9H4.12v-42.97h8.9v34.07h0ZM12.47,81.13h-2.3c-.08,0-.24.04-.48.12-.32.2-.48.48-.48.85v1.03h4.06v3.81H4.37v-3.81h1.03v-1.03c0-1.57.46-2.76,1.39-3.57.93-.81,2.06-1.21,3.39-1.21h2.3v3.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.74,124.52h8.17v8.9h-25.96v-8.9h8.65v-20.09h9.14v20.09ZM35.83,148.01h-7.87v-8.11h7.87v8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.59,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.27,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.94,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.62,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.3,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.2,104.43v17.55c0,1.49-.24,3.01-.73,4.54-1.49,2.95-3.53,4.9-6.11,5.87-1.45.69-2.88,1.03-4.3,1.03h-3.33c-1.17,0-2.36-.18-3.57-.54-1.05-.44-2.14-1.03-3.27-1.75-2.34,1.53-4.64,2.3-6.9,2.3h-23.12v-8.9h8.65v-15.55h8.9v15.55h5.57c.69,0,1.29-.26,1.82-.79.32-.56.48-1.15.48-1.75v-16.04h8.9v16.04c0,1.05.46,1.8,1.39,2.24.48.2.87.3,1.15.3h3.33c.65,0,1.23-.26,1.76-.79.32-.56.48-1.15.48-1.75v-17.55h8.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.39,124.52h8.65v8.9h-37.89c-.52,0-.95.08-1.27.24-.69.32-1.03,1.01-1.03,2.06v10.41h-9.14v-10.17c0-3.35.95-6.11,2.84-8.29,1.86-2.1,4.72-3.15,8.59-3.15h.79v-8.9c0-1.53.24-2.97.73-4.3.64-1.41,1.49-2.68,2.54-3.81,1.05-1.05,2.24-1.82,3.57-2.3,1.45-.69,2.91-1.03,4.36-1.03h17.25v20.33h0ZM212.49,113.33h-8.35c-.4,0-.75.08-1.03.24-.85.36-1.27,1.05-1.27,2.06v8.9h10.65v-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.48,104.43h4.05c1.53,0,2.97.24,4.3.73,2.94,1.41,4.98,3.45,6.11,6.11.52,1.45.79,2.99.79,4.6v.24h-8.9v-.24c0-.65-.18-1.25-.54-1.82-.48-.48-1.07-.73-1.76-.73h-4.05c-.65,0-1.25.24-1.82.73-.32.57-.48,1.17-.48,1.82v8.65h17.55v8.9h-35.1v-8.9h8.65v-8.65c0-1.53.24-3.07.73-4.6,1.17-2.66,3.21-4.7,6.11-6.11,1.37-.48,2.82-.73,4.36-.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.07,124.52h8.35v8.9h-17.25v-42.97h8.9v34.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.1,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.78,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.46,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.13,133.42h-16.1v-8.9h16.1v8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.96,90.45v15.98c.61-.32,1.13-.56,1.57-.73,1.49-.85,3.09-1.27,4.78-1.27h13.25c1.49,0,3,.24,4.54.73,2.9,1.49,4.86,3.53,5.87,6.11.69,1.45,1.03,2.91,1.03,4.36v8.9h8.35v8.9h-56.65v-8.9h8.35v-34.07h8.91ZM374.57,113.33h-13.25c-.36,0-.69.08-.97.24-.36.32-.71.67-1.03,1.03l-3.09,9.93h20.64v-8.9c0-.69-.21-1.24-.64-1.66s-.98-.64-1.66-.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.28,133.42h-37.34v-8.9h8.65v-8.9c0-1.53.24-2.97.73-4.3.69-1.41,1.53-2.68,2.54-3.81,1.09-1.09,2.28-1.85,3.57-2.3,1.45-.69,2.99-1.03,4.6-1.03h17.25v29.23h0ZM420.14,113.33h-8.11c-.85,0-1.61.34-2.3,1.03-.16.28-.24.71-.24,1.27v8.9h10.65v-11.2h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M626.13,5.3c.82.42,1.78.49,2.66.78,8.42,2.8,11.93,12.98,7.14,20.47-.95,1.48-2.04,2.09-3.06,3.26-.15.18-.18.24-.15.48,41.92,4.6,82.62,23.35,108.23,57.45,18.83,25.07,28.7,58.36,30.15,89.52.03.61.14,1.57-.21,2.03h-28.52l-.21-.21v-9.27l.21-.21h17.28c.08,0,.22-.24.22-.35-1.9-28.69-10.6-56.96-27.91-80.1-23.95-32.02-61.82-51-100.72-58.01-5.09,2.51-10.43,2.16-15.16-.92-39.24,5.69-78.21,23.7-103.47,54.78-16.48,20.27-26.16,44.99-29.77,70.79-.09.65-.2,1.32-.28,1.96-.49,3.77-.7,7.58-1.14,11.36-.02.12.15.35.22.35h17.28l.21.21v9.48c-.14-.05-.3.14-.35.14h-28.66c-.08-.06-.16-.13-.19-.23-.15-.46.34-3.3.4-4.05,2.04-26.28,7.73-50.87,20.96-73.84,23.07-40.02,64.22-62.94,109.22-69.87,4.9-.75,9.85-1.34,14.8-1.57.1-.58-.47-.65-.78-.98-6.88-7.45-4.31-19.42,5.42-22.68.88-.29,1.84-.39,2.66-.78h3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461.31,187.21l316.77-.04c4.2.07,4.66,5.63.56,6.33h-317.38c-3.86-.49-3.91-5.79.05-6.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552.51,67.09c.06.26-.15.33-.28.49-1.39,1.69-4.35,3.52-6.11,4.99-12.42,10.35-21.81,22.67-29.32,36.98-7.85,14.96-12.44,29.81-13.32,46.79-.04.82.18,4.18-.21,4.57-.12.12-1.98.25-2.39.28-2.19.15-4.42.03-6.6.29l-7.25-.07c-.19-.14-.13-.19-.08-.36.06-.2,1.59-2.05,1.88-2.47,5.37-7.86,6.27-17.39,9.09-26.3,7.54-23.82,25.04-49.65,47.41-61.59l7.17-3.58v-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M641.86,59.09v-1.25l14.68-.02c.43.11,1.89,2.3,1.89,2.46v88.33l.21.21h3.23l.21-.21v-73.17l.21-.21h14.47l.21-.35c-.45-.64-1.34-.24-2.02-.37l-.17-.11c-.15-.21-.1-2.53.1-2.66l1.85-.04.23-.19c.07-.14-.09-.49-.21-.49h-14.47c-.33-.3-.33-1.1,0-1.4h14.47c.2,0,.35-.73.08-.92-.89-.62-2.71,1.17-2.05-2.46.24-.35,1.7.06,2.05-.19.27-.19.13-.92-.08-.92h-14.47c-.39-.33-.16-.94-.21-1.4h14.54c.07,0,.37-.35.36-.5.03-1.13-1.89-.32-2.19-.76v-2.12l2.05-.19c.3-.21.05-.77,0-1.06h-14.54c-.33-.3-.33-1.1,0-1.4h14.33c.41,0,2.18,2.53,2.18,2.88v88.05l.21.21h3.51c.15,0,.2.53.35.63.29.21,1.4.09,1.69.7v5.69c-.68.21-1.51.29-1.89-.38-.06,0-.11.1-.15.1h-127.84l-.21-.21v-6.32l.21-.21h6.11v-46.55l.21-.21h14.61l1.47,1.62v44.94l.21.21h3.51l.21-.21v-73.17l.21-.21h14.47c.11,0,.28-.35.21-.49l-.23-.19-1.59-.02.06-2.68,1.63-.2c.29-.2.07-.64-.07-.64h-14.47c-.33-.3-.33-1.1,0-1.4h14.47l.21-.98-1.77-.13v-2.26l1.63-.19.13-.92h-14.68c-.33-.3-.33-1.1,0-1.4h14.47c.29-.16.31-.9.08-1.06l-1.7-.14v-2.31l1.7-.06c.23-.16.21-.9-.08-1.06h-14.47c-.32-.22-.31-.91-.01-1.14l14.69-.05,1.68,2.39.08,88.26c.03.07.25.28.28.28h3.3v-73.38l.21-.21h14.47c.14,0,.36-.44.07-.64l-1.63-.2v-2.55l1.63-.2c.29-.2.07-.64-.07-.64h-14.47c-.33-.3-.33-1.1,0-1.4h14.47c.2,0,.35-.73.08-.92l-1.67-.22.04-2.24,1.63-.19c.27-.19.13-.92-.08-.92h-14.47c-.33-.3-.33-1.1,0-1.4h14.54c.57-1.54-.62-1.07-1.69-1.12l.06-2.26,1.63-.19c.3-.21.05-.77,0-1.06h-14.54c-.34,0-.18-1.05-.07-1.26h14.68c.37.23,1.9,2.39,1.9,2.6v88.19l.21.21h3.3c-.05-.14.14-.3.14-.35v-73.24h14.89l-.13-.64-1.6-.08c-.43-.14-.21-2.2-.17-2.66l1.91-.13-.21-.7h-14.68v-1.4h14.89v-.98c-2.27.29-2.11-.44-1.91-2.4l1.91-.13v-.98h-14.68c-.39-.33-.16-.94-.21-1.4h14.68c.28-.16.31-.9.08-1.06l-1.77-.19v-2.12l1.77-.19c.23-.16.21-.9-.08-1.06h-14.68v-1.26h14.82l1.76,2.46v88.33l.21.21h3.23l.21-.21v-73.17l.21-.21h14.47c.14,0,.36-.44.07-.64l-1.35-.2v-2.55l1.35-.2c.29-.2.07-.64-.07-.64h-14.68l.02-1.17.33-.23,14.31-.02c1.02-1.34-1.09-.79-1.29-1.12.04-.45-.23-2.21.21-2.35l1.18-.08.07-.79-14.48-.13-.33-.23-.02-1.17h14.68c.29-.16.31-.9.08-1.06l-1.41-.06.06-2.26.17-.11c.99.07,1.78-.03,1.1-1.14h-14.68v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M522.03,166.73s.22-.25.28-.28l191.84-.09c.62.53,1.23,1.03,1.61,1.77v14.25l-193.73-.35v-15.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M702.2,156.69c.3,0,.6-.09.63-.08.17.07,1.41.95,1.41,1.13v7.93l-169.99-.14v-8.64l.21-.21h167.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M647.48,71.73c-.05.14.14.3.14.35v2.25l-.21.21h-2.53l-.21-.21v-2.25s.19-.21.14-.35h2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M674.04,71.73c-.05.14.14.3.14.35v2.25l-.21.21h-2.6c.05-.14-.14-.3-.14-.35v-2.11s.19-.21.14-.35h2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.86,71.73c-.05.14.14.3.14.35v2.11s-.19.21-.14.35h-2.6l-.21-.21v-2.25s.19-.21.14-.35h2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606.6,71.73c-.05.14.14.3.14.35v2.11s-.19.21-.14.35h-2.6l-.21-.21v-2.25s.19-.21.14-.35h2.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "651 71.73 651 74.53 648.4 74.53 648.19 74.32 648.19 71.94 648.4 71.73 651 71.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M630.34,71.73c-.05.14.14.3.14.35v2.25l-.21.21h-2.6v-2.81h2.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "610.11 71.73 610.11 74.53 607.52 74.53 607.3 74.32 607.3 71.94 607.52 71.73 610.11 71.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "624.16 74.53 624.16 71.94 624.37 71.73 626.76 71.73 626.97 71.94 626.97 74.32 626.76 74.53 624.16 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "586.37 74.53 583.77 74.53 583.56 74.32 583.56 71.94 583.77 71.73 586.16 71.73 586.37 71.94 586.37 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "613.63 74.53 611.03 74.53 610.82 74.32 610.82 71.94 611.03 71.73 613.42 71.73 613.63 71.94 613.63 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "654.51 74.53 651.91 74.53 651.7 74.32 651.7 71.94 651.91 71.73 654.3 71.73 654.51 71.94 654.51 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "664.34 74.53 664.34 71.94 664.55 71.73 666.94 71.73 667.15 71.94 667.15 74.32 666.94 74.53 664.34 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "667.85 74.53 667.85 71.94 668.07 71.73 670.45 71.73 670.66 71.94 670.66 74.32 670.45 74.53 667.85 74.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "587.28 71.73 589.67 71.73 589.88 71.94 589.88 74.32 589.67 74.53 587.28 74.53 587.07 74.32 587.07 71.94 587.28 71.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "590.8 71.73 593.19 71.73 593.4 71.94 593.4 74.32 593.19 74.53 590.8 74.53 590.59 74.32 590.59 71.94 590.8 71.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M644.9,66.13l2.59.04c.49,2.29.15,2.78-2.19,2.47-1.03-.14-.57-1.62-.56-2.4l.17-.11h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M633.86,66.11c.14.52.36,2.22-.14,2.46-.33.16-2.32.15-2.54-.13-.21-.27-.25-2,.08-2.33h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M671.61,66.14c.26-.08,2.29-.07,2.44.03.49,2.29.15,2.78-2.19,2.47-1.02-.14-.75-2.36-.25-2.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M604.02,66.13c2.24-.12,3.23-.37,2.59,2.31-.23.3-2.34.29-2.63.07-.36-.29-.19-1.78-.14-2.27l.17-.11h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627.68,66.11h2.6c.34.33.3,2.06.08,2.33-.25.31-2.67.4-2.8-.18l.12-2.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651,66.11l.11,2.16-.25.3c-.52.07-2.25.24-2.54-.13-.21-.27-.25-2,.08-2.33h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M664.34,66.32l.23-.19c.8.05,1.91-.25,2.58.19v2.11l-.23.19c-.8-.05-1.91.25-2.58-.19v-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M670.66,68.5c-.09.14-2.54.32-2.81-.07v-2.11c.67-.35,2.15-.34,2.81,0v2.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.82,68.5v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.11c-.24.39-2.81.21-2.81.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M626.97,68.5c-.09.14-2.54.32-2.81-.07v-2.11c.67-.35,2.15-.34,2.81,0v2.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.7,68.5v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.11c-.24.39-2.81.21-2.81.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.3,68.5v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.11c-.24.39-2.81.21-2.81.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.56,68.5v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.11c-.24.39-2.81.21-2.81.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.4,68.5c-.9.22-1.91.22-2.81,0v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.88,68.5c-.9.22-1.91.22-2.81,0v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "604.02 60.23 606.61 60.27 606.68 62.47 603.92 62.54 603.85 60.34 604.02 60.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "631.28 60.23 633.87 60.27 633.94 62.47 631.18 62.54 631.11 60.34 631.28 60.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "644.9 60.23 647.49 60.27 647.56 62.47 644.81 62.54 644.74 60.34 644.9 60.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "671.46 60.23 674.05 60.27 674.12 62.47 671.36 62.54 671.29 60.34 671.46 60.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627.68,62.6v-2.39h2.6l.19.23c-.04.67.23,1.62-.19,2.15h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651,60.21v2.39h-2.6c-.35-.54-.34-1.86,0-2.39h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M667.85,62.6v-2.39h2.6l.19.23c-.04.67.23,1.62-.19,2.15h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.11,60.21v2.39h-2.6l-.19-.23c.04-.67-.23-1.62.19-2.15h2.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "593.4 62.6 590.59 62.6 590.59 60.21 593.19 60.21 593.4 60.42 593.4 62.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.37,60.21v2.39h-2.6l-.19-.23c.04-.67-.23-1.62.19-2.15h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.88,62.6h-2.81v-2.18l.23-.19c.8.05,1.91-.25,2.58.19v2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.63,60.21v2.39h-2.6l-.19-.23c.04-.67-.23-1.62.19-2.15h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624.16,62.6v-2.39h2.6l.19.23c-.04.67.23,1.62-.19,2.15h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M664.34,62.6v-2.39h2.6l.19.23c-.04.67.23,1.62-.19,2.15h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M654.51,60.21v2.39h-2.6l-.19-.23c.04-.67-.23-1.62.19-2.15h2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M641.86,74.53v-2.6c.26-.35,2.05-.28,2.19-.08.03.82.27,1.99-.15,2.68h-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.09,66.13l1.96.11c.05.49.23,1.99-.14,2.27-.31.19-1.83.23-1.99,0-.04-.44-.25-2.24.17-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.07,71.75c.25.16.19,2.24.1,2.66l-1.77.07-.07-2.62,1.74-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M641.86,62.6v-2.39h2.04l.19.23c-.04.67.23,1.62-.19,2.15h-2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "582.86 71.73 582.86 74.53 581.09 74.4 581.09 71.86 582.86 71.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "621.63 74.53 621.63 71.73 623.4 71.86 623.4 74.4 621.63 74.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.49,66.13l1.68.11c.05.51.26,2.09-.22,2.33-.33.16-1.43.17-1.62-.21-.15-.3-.18-2.12.16-2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601.49,60.23l1.68.11-.07,2.19-1.77-.07c-.05-.42-.25-2.1.17-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.46,68.5c-.07.11-1.65.32-1.83-.07v-2.32c.58.08,1.38-.21,1.83.21v2.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.03,68.5v-2.18c.38-.34,1.43-.34,1.83,0v2.11c-.18.4-1.83.16-1.83.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "621.63 62.6 621.63 60.21 623.4 60.34 623.4 62.47 621.63 62.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "582.86 60.21 582.86 62.6 581.09 62.47 581.09 60.34 582.86 60.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M662.09,71.94l.23-.19c.18-.04.36-.03.54-.03.29,0,.59-.05.77.22v2.39l-.23.19c-.18.04-.36.03-.54.03-.29,0-.59.05-.77-.22v-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.64,68.5c-.54.19-1,.19-1.55,0v-2.18l.23-.19c.18-.04.36-.03.54-.03.29,0,.59-.05.77.22v2.18h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.64,60.21v2.39h-1.55v-2.18c.37-.4,1.04-.15,1.55-.21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.abb74250b988e7622c2bf45ad3882039.svg";
export { ForwardRef as ReactComponent };